import { combineReducers } from 'redux';
import formsReducer from './reducers/formsReducer';
import apiReducer from './reducers/apiReducer';
import onboardingFormReducer from './slice/onboardingFormSlice';

const rootReducer = combineReducers({
  forms: formsReducer,
  api: apiReducer,
  formPath: onboardingFormReducer
});

export default rootReducer;